module.exports = __webpack_public_path__ + "edit_3.6fbf2ba4020503d79935c6b86f1872bd.svg";